interface EcosystemRecord {
	tags: string[];
	el: HTMLElement;
}

class EcosystemCollection {
	recordsData: EcosystemRecord[] = [];

	DOM!: {
		typeSelect: HTMLSelectElement;
		droneSelect: HTMLSelectElement;
		records: NodeListOf<HTMLElement>;
	};

	constructor() {
		this.DOM = {
			typeSelect: document.querySelector('.js-type') as HTMLSelectElement,
			droneSelect: document.querySelector('.js-droneType') as HTMLSelectElement,
			records: document.querySelectorAll('.js-record'),
		};
		this.events();
		this.setRecordsData();
	}

	events() {
		this.DOM.typeSelect.addEventListener('change', this.onChange.bind(this));
		this.DOM.droneSelect.addEventListener('change', this.onChange.bind(this));
	}

	onChange() {
		const type = this.DOM.typeSelect.value;
		const drone = this.DOM.droneSelect.value;

		for (let i = 0; i < this.recordsData.length; i++) {
			if (
				(this.recordsData[i].tags.indexOf(type) > -1 || type === '*') &&
				(this.recordsData[i].tags.indexOf(drone) > -1 || drone === '*')
			) {
				this.recordsData[i].el.classList.add('js-active');
			} else {
				this.recordsData[i].el.classList.remove('js-active');
			}
		}
	}

	setRecordsData() {
		this.recordsData = Array.from(this.DOM.records).map((el) => ({
			tags: (el.dataset.tags ?? '').split(','),
			el,
		}));
	}
}

new EcosystemCollection();
